import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import Header from "@/components/Header";
import BottomBar from "@/components/BottomBar";
import userVerificationProcess01 from "@/assets/images/help/user-verification-process-01.png";

export default function HelpUserVerification() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header showBack={true} onBackClick={() => navigate("/help")} />

      <div className="max-w-md mx-auto px-4 pb-20">
        {/* Title */}
        <div className="mt-6 mb-6">
          <h1 className="text-2xl font-bold mb-2">
            Beginner's Guide: User Verification Process
          </h1>
        </div>

        {/* Content */}
        <div className="space-y-6">
          {/* Introduction */}
          <div className="space-y-2">
            <p className="text-sm font-semibold whitespace-pre-line">
              To use Fellas Card, you must first complete user verification.
              {"\n\n"}
              User verification is a required step in the Fellas Card onboarding
              process and must be completed to access all services.
              {"\n\n"}
              Verification only needs to be done once.
            </p>
          </div>

          {/* Steps Overview */}
          <div className="space-y-2">
            <p className="text-sm font-semibold whitespace-pre-line">
              The user verification process consists of the following four
              steps:
              {"\n"}· User Registration – Enter basic account information
              {"\n"}· Address Entry – Register your residential address
              {"\n"}· KYC – Verify your identity and residence
              {"\n"}· Wallet Creation – Your personal wallet is automatically
              created after verification
            </p>
          </div>

          {/* Image Section */}
          <div className="space-y-4">
            <p className="text-sm font-semibold">
              Click the "Register Now" button to start the user verification
              process.
            </p>
            <div className="rounded-lg overflow-hidden shadow-md">
              <img
                src={userVerificationProcess01}
                alt="User Verification Process"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>

        {/* Next Step */}
        <div className="mt-8">
          <Button
            onClick={() => navigate("/help/3")}
            className="w-full h-12 flex items-center justify-between"
          >
            <span>Next: User Registration</span>
            <ChevronRight className="w-5 h-5" />
          </Button>
        </div>
      </div>

      <BottomBar />
    </div>
  );
}
